import { LitElement, html, css } from 'lit';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
class SynapseIcon extends LitElement {
    static get properties() {
        return {
            svg: { type: String },
        };
    }
    static get styles() {
        return css `
    :host {
      display: inline-block;
      height: var(--goto-icon-height, var(--goto-icon-size, 18px));
      pointer-events: none;
    }

    :host([path-fill]) path {
      fill: var(--icon-color-default)
    }

    :host([path-invert-fill]) path {
      fill: var(--icon-color-inverted)
    }

    :host([disabled]) path {
      fill: var(--icon-color-disabled);
    }

    .icon {
      color: var(--goto-icon-color, --goto-text-01);
      display: flex;
      width: var(--goto-icon-width, var(--goto-icon-size, 18px));
      height: var(--goto-icon-height, var(--goto-icon-size, 18px));
      margin: var(--goto-icon-margin, 0);
      user-select: none;
    }

    .icon svg {
      width: 100%;
      height: 100%;
    }
    `;
    }
    constructor() {
        super();
        this.svg = null;
    }
    render() {
        return html `
      <div class="icon">
        ${this.renderIcon()}
      </div>
    `;
    }
    renderIcon() {
        if (!this.svg)
            return null;
        return unsafeSVG(this.svg);
    }
}
customElements.define('synapse-icon', SynapseIcon);
